import { Component, EventEmitter, Injector, Input, OnInit, Output, forwardRef } from '@angular/core';
import { SessionBaseComponent } from '../../session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from 'src/app/core/models/laas-option';
import { AuthTenantService } from 'src/app/core/services/auth/tenant/auth-tenant.service';
import { deepCopy, getTenantByPermission } from 'src/app/core/utils/common-functions';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const LAAS_TENANT_DROPDOWN_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TenantDropdownComponent),
  multi: true
};

@Component({
  selector: 'laas-tenant-dropdown',
  templateUrl: './tenant-dropdown.component.html',
  styleUrls: ['./tenant-dropdown.component.scss'],
  providers: [LAAS_TENANT_DROPDOWN_ACCESSOR]
})
export class TenantDropdownComponent extends SessionBaseComponent implements OnInit, ControlValueAccessor {

  @Input() divClass: string = '';
  @Input() labelClass: string = '';
  @Input() dropdownStyle: any = {};
  @Input() showLabel: boolean = false;
  @Input() showClear: boolean = true;
  @Input() showFilter: boolean = true;
  @Input() permissionCode!: PermissionConstants;
  @Input() isSingle: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() showToggleAll: boolean = false;
  @Input() showAllOptionItem: boolean = false;

  @Output() onOptionDataChange: EventEmitter<any> = new EventEmitter();

  virtualScroll: boolean = false;
  tenantOptionsByPermission: LaasOption[] = [];
  allOptionItem: LaasOption = {
    value: "ALL",
    label: "ALL - 全部"
  };

  value: any;
  onChangeFn: (value: any) => void = () => {};
  onTouched: () => void = () => {};
  disabled = false;

  constructor(
    injector: Injector,
    private tenantService: AuthTenantService,
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.tenantService.getTenantOptions().subscribe({
      next: (options: any[]) => {
        const tenantByPermission = getTenantByPermission(this.userProfile, this.permissionCode);
        const isAllNull = tenantByPermission.every((x: any) => x == null);
        const tenantOptionsByPermission = options.filter(x =>
          this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            isAllNull || tenantByPermission.includes(x.tenantCode));

        this.tenantOptionsByPermission = (deepCopy(tenantOptionsByPermission) as any[])
          .map(x => ({ value: x.tenantCode, label: `${x.tenantCode} - ${x.tenantName}` }));

        if (this.showAllOptionItem) {
          this.tenantOptionsByPermission.unshift(this.allOptionItem);
        }

        this.virtualScroll = this.tenantOptionsByPermission && this.tenantOptionsByPermission.length > 30;
      }
    });

  }

  onValueChange(event: any): void {
    this.value = event;
    this.onChangeFn(this.value);
    this.onTouched();
    this.onOptionDataChange.emit(event);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
